import React from 'react';
import { get, keyBy } from 'lodash';
import { httpsCallable } from 'firebase/functions';
import { toast } from 'react-toastify';

import { db, functions } from '../../firebase';
import useCollectionSubscription from '../hooks/useCollectionSubscription';
import { collection, query, orderBy } from 'firebase/firestore';
import AdminPage from '../AdminPage';
import ProgressButton from '../ProgressButton';

const forceEmailVerified = httpsCallable(functions, 'forceEmailVerified');

export default function AdminUsers() {
  return (
    <AdminPage>
      <PageContent />
    </AdminPage>
  );
}

function PageContent() {
  const users = useCollectionSubscription(query(collection(db, 'users'), orderBy('email')));
  const tenants = useCollectionSubscription(query(collection(db, 'tenants')));
  const tenantsById = keyBy(tenants, 'id');

  return (
    <div className="admin-users container-fluid">
      <div className="p-4 bg-white my-4">
        <div className="d-flex justify-content-center mb-3">
          <h4>ユーザー管理</h4>
        </div>
        <div className="overflow-scroll">
          <table className="table">
            <thead className="thead-light text-center">
              <tr className="text-nowrap">
                <th>テナント名</th>
                <th>ユーザー名</th>
                <th>メールアドレス</th>
                <th>ID</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {
                users.map((user) => {
                  const { id, email, displayName, tenantId } = user;
                  const tenant = tenantsById[tenantId];

                  return (
                    <tr key={id}>
                      <td>
                        {tenant?.name}
                      </td>
                      <td>
                        {displayName}
                        {user.admin && (
                          <span className="badge bg-info ms-2">admin</span>
                        )}
                      </td>
                      <td>
                        {email}
                      </td>
                      <td>
                        {id}
                      </td>
                      <td>
                        <ProgressButton
                          color="secondary"
                          process={async () => {
                            if (!window.confirm('このユーザーのメール認証を強制的にOKにしますか？')) return;

                            try {
                              await forceEmailVerified({ uid: id });
                              toast.success('メール認証を強制的にOKにしました');
                            } catch (e) {
                              toast.error('失敗しました');
                              console.error(e);
                            }
                          }}
                        >
                          強制メール認証
                        </ProgressButton>
                      </td>
                    </tr>
                  );
                })
              }
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
